import { Check, X } from 'lucide-react';

const ProsConsList = ({ pros = [], cons = [] }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6" data-testid="pros-cons-list">
      {/* Pros */}
      <div className="bg-teal-50 border border-teal-200 rounded-sm p-6">
        <h4 className="font-heading font-bold text-teal-800 mb-4 flex items-center gap-2">
          <div className="flex items-center justify-center w-6 h-6 bg-teal-600 rounded-full">
            <Check className="w-4 h-4 text-white" />
          </div>
          Vorteile
        </h4>
        <ul className="space-y-3">
          {pros.map((pro, index) => (
            <li key={index} className="flex items-start gap-3 text-sm text-teal-900">
              <Check className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" />
              <span>{pro}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Cons */}
      <div className="bg-red-50 border border-red-200 rounded-sm p-6">
        <h4 className="font-heading font-bold text-red-800 mb-4 flex items-center gap-2">
          <div className="flex items-center justify-center w-6 h-6 bg-red-500 rounded-full">
            <X className="w-4 h-4 text-white" />
          </div>
          Nachteile
        </h4>
        <ul className="space-y-3">
          {cons.map((con, index) => (
            <li key={index} className="flex items-start gap-3 text-sm text-red-900">
              <X className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
              <span>{con}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProsConsList;
